import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/glasses.webp'

export const Glasses: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'glasses'} />
)
